<div class="logo-box p-4 d-flex">
  <img src="assets/svg/logo.svg" class="my-auto" height="100" [hidden]="toggled" />
  <a class="mb-auto d-none d-sm-block" (click)="toggleSidebar()" [ngClass]="{
      'ms-auto': !toggled,
      'mx-auto': toggled
    }">
    <i class="bi bi-filter-right text-size-28px text-default"></i>
  </a>

  <a class="mb-auto mx-auto d-block d-sm-none" (click)="hideSidebar()">
    <i class="bi bi-filter-right text-size-28px text-default"></i>
  </a>
</div>

<div class="d-flex flex-column flex-grow-1 side-items pb-5 pb-sm-0">
  <div class="px-4" *ngFor="let item of menuItems">
    <ng-container *ngxPermissionsOnly="item.permissions">
      <a class="menu-item mb-md-2" href="{{ item.route }}" target="_blank" *ngIf="item.redirect == true">
        <i class="am am-{{ item.icon }} my-auto" [routerLinkActive]="['text-primary']" [ngClass]="{
            'mx-auto': toggled
          }" *ngIf="item.setImg == false"></i>
        <img src="{{ item.urlImg }}" alt="" *ngIf="item.setImg == true" width="30px" height="30px" class="my-auto" />
        <span class="ms-3 semibold my-auto" (click)="hideSidebar()" [routerLinkActive]="['text-primary']"
          *ngIf="!toggled">{{ item.title }}</span>
      </a>
      <a [routerLink]="[]" class="menu-item mb-md-2" [routerLink]="[item.route]" *ngIf="item.redirect == false">
        <i class="am am-{{ item.icon }} my-auto" [routerLinkActive]="['text-primary']" [ngClass]="{
            'mx-auto': toggled
          }" *ngIf="item.setImg == false"></i>
        <img src="{{ item.urlImg }}" alt="" *ngIf="item.setImg == true" width="30px" height="30px" class="my-auto"
          [routerLinkActive]="['side-item-img-active']" />
        <span class="ms-3 semibold my-auto" (click)="hideSidebar()" [routerLinkActive]="['text-primary']"
          *ngIf="!toggled">{{ item.title }}</span>
      </a>

      <div *ngIf="item.submenus?.length && !toggled" class="sidebar-submenu"
        [ngClass]="{ collapse: item.route != currentUrl }">
        <ng-container *ngFor="let subitem of item.submenus">
          <a class="submenu-item" (click)="hideSidebar()" [routerLinkActive]="['text-primary']"
            [routerLink]="[item.route, subitem.route]" *ngxPermissionsOnly="subitem.permissions || item.permissions">
            <span>{{ subitem.title }}</span>
            <!-- <span class="badge ms-auto me-2" *ngIf="subitem.badgeText">{{subitem.badgeText}}</span> -->
          </a>
        </ng-container>

      </div>
    </ng-container>

  </div>
  <div class="px-4">
    <a class="menu-item mb-4" [routerLink]="[]" (click)="logout()">
      <i class="am am-exit my-auto"></i>
      <span class="ms-3 semibold my-auto" *ngIf="!toggled">Salir</span>
    </a>
  </div>
</div>